import layout from '@/views/layout/layout.vue'
const customerList = r => require.ensure([], () => r(require('@/views/ywt/customer/list.vue')), 'group-ywt-member')

const ywtCustomer = [
  {
    path: '/ywt/customer',
    name: 'ywt-customer',
    component: layout,
    redirect: '/ywt/customer/list',
    children: [
      {
        path: 'list',
        name: 'ywt-customer-list',
        component: customerList,
        meta: {
          displayName: '消费者管理',
          requireAuth: true
        }
      }
    ]
  }
]

export default ywtCustomer



// WEBPACK FOOTER //
// ./src/router/ywt/customer.js